import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/center/notifications";

export const notifications = {
    // ...example,
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
}
